import * as React from 'react';

import { cn } from './lib/cn';

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, title, description, icon, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-col items-center justify-center gap-3 px-6 py-12 text-center', className)}
      {...props}
    >
      {icon !== undefined && <div className="text-text-tertiary">{icon}</div>}
      <h3 className="text-3xl font-semibold tracking-tight text-text-primary">{title}</h3>
      {description !== undefined && <p className="max-w-md text-base text-text-tertiary">{description}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  ),
);
EmptyState.displayName = 'EmptyState';

export { EmptyState };
